import { barkApi } from '@bark/bark-core/src/components/legacy-scripts/barklib';
import { loadStripe } from '@stripe/stripe-js/pure';

/** @type Stripe */
export let stripe;

export const initStripeLibrary = (userId, attempt = 1) => {
	if (stripe) {
		return Promise.resolve();
	}
	if (attempt > 3) {
		return Promise.reject(new Error('Failed to Init payment modal'));
	}
	return new Promise((resolve, reject) => {
		console.log(`Loading Stripe JS Library attempt ${attempt}`);
		barkApi(
			`user/${userId}/billing`,
			null,
			(response) => {
				const gatewayPubKey = response.data.gatewayPubKey;
				const stripeLoadPromise = loadStripe(gatewayPubKey);

				stripeLoadPromise
					.then((stripeApi) => {
						console.log('Stripe JS Library Loaded');
						stripe = stripeApi;
						resolve();
					})
					.catch(() => {
						// something failed, we should just retry
						initStripeLibrary(userId, attempt + 1)
							.then(resolve)
							.catch(reject);
						console.warn('Failed to load Stripe API');
					});
			},
			() => {
				// something failed, we should just retry
				initStripeLibrary(userId, attempt + 1)
					.then(resolve)
					.catch(reject);
				console.warn('Failed to get user billing info');
			},
		);
	}).catch((err) => {
		window.bugsnagClient.notify(new Error('Failed to Init payment modal'), {
			metaData: { userId: userId, err: err, attempt: attempt },
		});
	});
};
